/** Interfaces */
import { ThemeInterface } from '../interfaces/theme.interface';
import { DefectInfoInterface } from '../interfaces/defects-info.interface';
/** Models */
import { Campaign } from '../../campaign.class';
import { EnabledDefectLot } from './enabled-defect-lot';
import { Lot } from './lot';
import { Theme } from './theme';
import { LotInterface } from '../interfaces/lot.interface';
import { EnabledDefectLotInterface } from '../interfaces/enabled-defect-lot.interface';

export class DefectInfo {
  /**
   *
   */
  public lots: Lot[] = [];

  /**
   *
   */
  public themes: ThemeInterface[] = [];

  /**
   *
   */
  public campaigns: Campaign[] = [];

  /**
   *
   */
  public enabledDefectLots: EnabledDefectLot[] = [];

  /**
   * Creates an instance of DefectInfo.
   *
   * @param info the json data
   */
  public constructor(info: DefectInfoInterface) {
    this.themes = info.themes.map(
      (theme: ThemeInterface) => new Theme(theme.id, theme.label, theme.parentId, theme.lotId)
    );
    this.lots = info.lots.map((lot: LotInterface) => new Lot(lot.id, lot.label, lot.parentId));
    this.campaigns = info.campaigns.map(
      (campaign: Campaign) => new Campaign(campaign.campaignId, campaign.campaignName, campaign.availableForDefects)
    );
    this.enabledDefectLots = info.enabledDefectLots.map(
      (enabledDefectLot: EnabledDefectLotInterface) =>
        new EnabledDefectLot(enabledDefectLot.enabledLotId, enabledDefectLot.campaignId)
    );
  }
}
